<template>
    <div class="pl-6 pr-4 py-2 w-full flex even:bg-white odd:bg-gray-50 border-b border-gray-300 ">
        <div class="tracking-wide font-semibold pr-1 w-[8%] text-dark-primary">{{ index + 1 }}</div>
        <div class="w-[92%]">
            <div 
                v-for="(field, index) in fields"
                :key="index"
                class="flex flex-col border-b border-gray-300 first:py-0 first:pb-1.5 py-1.5 last:border-none"
            >
                <div class="font-semibold tracking-wide pb-0.5">{{ field.fieldName }}:</div>
                <div class="whitespace-pre-wrap">{{ field.fieldValue }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['index', 'result', 'displayedFields'])

const fields = computed(() => {
    let fieldsToDisplay = []
    if(props.displayedFields && props.displayedFields.length > 0) {
        props.displayedFields.forEach((fieldName) => {
            fieldsToDisplay.push({
                fieldName: fieldName,
                fieldValue: props.result[fieldName] ? props.result[fieldName] : '--'
            })
        })
    } else {
        Object.keys(props.result).forEach((key) => {
            fieldsToDisplay.push({
                fieldName: key,
                fieldValue: props.result[key]
            })
        })
    }
    return fieldsToDisplay
})


</script>